module.exports = __webpack_public_path__ + "static/img/appback3.1eac207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/appback3.png
// module id = dSQI
// module chunks = 0